<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon small class="mr-2 ml-2">
          {{icon}}
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="grey lighten-2 pt-2">
        Conferma per continuare
      </v-card-title>
      <v-card-text class="pt-4">
        {{text}}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
            color="error"
            text
            @click="dialog = false"
        >
          Annulla
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="action"
        >
          Conferma
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:'actions-confirm',
  props: {
    icon: {
      type: String,
    },
    text: {
      type: String,
    },
    method: {
      type: Function
    },
  },
  methods: {
    action() {
      this.dialog = false
      this.$emit('method')
    }
  },
  data() {
    return {
      dialog: false
    }
  }
}
</script>
